module.exports = __webpack_public_path__ + "files/291c47d2e51a6a520780109a8db8d395.png";